import { render, staticRenderFns } from "./pictureCenterMobile.vue?vue&type=template&id=3aff37fe&scoped=true&"
import script from "./pictureCenterMobile.vue?vue&type=script&lang=js&"
export * from "./pictureCenterMobile.vue?vue&type=script&lang=js&"
import style0 from "./pictureCenterMobile.vue?vue&type=style&index=0&id=3aff37fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff37fe",
  null
  
)

export default component.exports